import React from 'react';
import maintenanceImg from '../../assets/images/vigilant.ai.jpg';
import './Maintenance.css';

const Maintenance = () => (
  <div className="maintenance-container">
    <img src={maintenanceImg} alt="Maintenance" className="maintenance-img" />
   
   
  </div>
);

export default Maintenance; 